<template>
  <v-container fluid ma-0 pa-0 px-4 id="newteam-main">
    <div class="fixed-header" :class="{ 'mobile': $vuetify.breakpoint.smAndDown }">
      <!-- if has summary fields add class 'with-summary' -->
      <v-layout align-center fill-height class="fixed-header-wrapper">
        <v-flex shrink class="text-truncate" pr-4>
          <v-tooltip color="secondary" bottom>
            <template v-slot:activator="{ on }">
              <h2 v-on="on" class="p-relative text-truncate">
                New Team
              </h2>
            </template>
            <span>Teams</span>
          </v-tooltip>
          <h4 class="pt-1 sub-header ">Teams - <span class="font-weight-bold">{{ teamCount }}</span></h4>
        </v-flex>
        <v-spacer></v-spacer>
        <v-divider vertical></v-divider>
        <v-flex shrink fill-height class="action">
          <v-tooltip left color="secondary">
            <v-btn icon flat slot="activator" @click="newTeam()">
              <v-icon color="success" size="24">add_circle</v-icon>
            </v-btn>
            <span>Create a new Team</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </div>
    <v-layout row wrap fluid class="card-margin-fix">
      <v-flex>
        <v-layout mb-2 mx-2 mt-4>
          <v-flex>
            <label>Display Name</label>
            <v-text-field id="newteam-name-text" label="Display Name" v-model="team.displayName"
              placeholder="e.g. Sales" solo flat>
            </v-text-field>
            <v-switch v-model="team.commsEnabled" color="secondary" label="Enable Commsroom"></v-switch>
            <v-switch v-model="team.metricsEnabled" color="secondary" label="Enable Metrics"></v-switch>
            <v-switch v-if="canToggleChat" v-model="team.chatEnabled" color="secondary" label="Enable Chat"></v-switch>
          </v-flex>
        </v-layout>
        <v-flex xs6 style="float:right;">
          <v-btn id="newteam-cancel-btn" color="error" @click="cancelCreate">Cancel</v-btn>
          <v-btn id="newteam-create-btn" color="success" @click="createTeam">Create Team</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      team: {
        displayName: "",
        commsEnabled: false,
        metricsEnabled: false,
        chatEnabled: false,
      }
    }
  },
  computed: {
    canToggleChat() {
      const email = this.$store.state.currentUser && this.$store.state.currentUser.me && this.$store.state.currentUser.me.email
      return email && String(email).toLowerCase().endsWith("@caseblocks.com")
    },
    ...mapState({
      teams: state => state.teams.all
    }),
    teamCount() {
      if (this.teams && this.teams.length > 0) {
        return this.teams.length
      } else {
        return 0
      }
    }
  },
  methods: {
    async createTeam() {
      await this.$store.dispatch("createTeam", this.team)
    },
    cancelCreate() {
      this.team.displayName = ""
      this.$router.push({ name: "Teams" })
    }
  }
}
</script>
